import Axios from "../../api/Axios";
const BASE_URL = "ExcluAutoAlloProd/";

export const EndpointHoldProductForAutoAllocation = {
    PopulateProduct: "PopulateProduct",
    SaveDeleteExclude: "SaveDeleteExclude"

};

export const createAPIEndpointHoldProductForAutoAllocation = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
